<template>
    <div>
        <common-table :table-columns="tableColumns" :form-fields="{model: []}" :permission="[]" :url="url" :searchs="[]" :operate="[]"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "UserTaskData",
        components: {CommonTable},
        data() {
            return {
                url: {
                    get: '/userTaskData/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'userId',
                    label: '用户昵称',
                    selectUrl:'/userInfo/getAll',
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'taskNum',
                    label: '任务数',
                    show: true,
                    width: '',
                }, {
                    field: 'orderNum',
                    label: '单数',
                    show: true,
                    width: '',
                }, {
                    field: 'completeNum',
                    label: '已完成',
                    show: true,
                    width: '',
                }]
            }
        }
    }
</script>

<style scoped>

</style>
